import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import "./AboutUsDetail.css";
import Summary from "../pages/summaryWithoutMembership";
import FooterNew from "../Components/FooterNew";

import QuickLinks from "./QuickLinks";
import { Link } from "react-router-dom";

const AboutUsDetail = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div className="parent-main-AboutUsDetail">
      <div className="nav-header-AboutUsDetail">
        <Navbar />
        <div className="Main-Header-Container">
          <section
            className="py-xxl-10 pb-0"
            id="home"
            style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
          >
            <div
              className="bg-holder"
              style={{
                backgroundImage: `url(${heroBgImage})`,
                backgroundPosition: "bottom",
                backgroundSize: "cover",

                //   height: "100vh", // Add a height to ensure background is visible
              }}
            />

            <div className="container">
              <div className="row min-vh-xl-100 min-vh-xxl-25">
                <div className=" paddin-header   text-center ">
                  <h2 className="">
                    <span
                      className=" general-tittle-mbl"
                      style={{
                        fontSize: "48px",
                        fontFamily: "Raleway, sanf-serif",
                        color: "#fff",
                        paddingBottom: " 10px",
                      }}
                    >
                      About 
                    </span>
                  </h2>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="summary-AboutUsDetail">
        <Summary />
      </div>
      <div className="education-tittle-about text-center">
        <h2>Qualifications </h2>
      </div>
      <div className="inner-edu-about">
        <ol
          className="row"
          style={{
            listStyleType: "disc",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "evenly",
            marginLeft: "20px",
            marginTop: "60px",
            marginBottom: "50px",
            fontSize: "18px",
            fontWeight: "550",
            letterSpacing: ".225px",
            fontFamily: "Open Sans sans-serif",
          }}
        >
          <li
            className="col-lg-6 col-md-6 col-sm-12"
            style={{ textAlign: "start" }}
          >
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              Link to GMC register for Dr Imtiaz Ahmed{" "}
            </h5>
            <p>
              <a
                className="gmc-tag"
                href="https://www.gmc-uk.org/doctors/4165334"
                target="_blank"
                rel="noopener noreferrer"
              >
                GMC Register Link
              </a>
            </p>
          </li>
          <li
            className="col-lg-6 col-md-6 col-sm-12"
            style={{ textAlign: "start" }}
          >
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              BSc / Punjab University, Lahore / 1984
            </h5>
            <p
              style={{
                color: "#363636",
                fontFamily: "'Raleway', sans-serif",
                fontWeight: "550",
                letterSpacing: ".44px",
                fontSize: "18px",
              }}
            >
              Bachelor of Science
            </p>
          </li>
          <li
            className="col-lg-6 col-md-6 col-sm-12"
            style={{ textAlign: "start" }}
          >
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              MBBS / King Edward Medical College, Lahore / 1987
            </h5>
            <p
              style={{
                color: "#363636",
                fontFamily: "'Raleway', sans-serif",
                fontWeight: "550",
                letterSpacing: ".44px",
                fontSize: "18px",
              }}
            >
              Bachelor of Medicine, Bachelor of Surgery
            </p>
          </li>
          <li
            className="col-lg-6 col-md-6 col-sm-12"
            style={{ textAlign: "start" }}
          >
            <h5 style={{ color: "#363636" }}>
              MRCP / Royal College of Physicians, UK / 1994
            </h5>
            <p
              style={{
                color: "#363636",
                fontFamily: "'Raleway', sans-serif",
                fontWeight: "550",
                letterSpacing: ".44px",
                fontSize: "18px",
              }}
            >
              MRCP / Royal College of Physicians, UK / 1994
            </p>
          </li>
          <li
            className="col-lg-6 col-md-6 col-sm-12"
            style={{ textAlign: "start" }}
          >
            <h5 style={{ color: "#363636" }}>
              CCST / Royal College of Physicians, UK / 2001
            </h5>
            <p
              style={{
                color: "#363636",
                fontFamily: "'Raleway', sans-serif",
                fontWeight: "550",
                letterSpacing: ".44px",
                fontSize: "18px",
              }}
            >
              Board Certification in Dermatology
            </p>
          </li>
          <li
            className="col-lg-6 col-md-6 col-sm-12"
            style={{ textAlign: "start" }}
          >
            <h5 style={{ color: "#363636" }}>
              FRCP / Royal College of Physicians, UK / 2007
            </h5>
            <p
              style={{
                color: "#363636",
                fontFamily: "'Raleway', sans-serif",
                fontWeight: "550",
                letterSpacing: ".44px",
                fontSize: "18px",
              }}
            >
              Fellowship of the Royal College of Physicians
            </p>
          </li>
        </ol>
      </div>
      <div className="education-tittle-about text-center">
        <h3>Professional memberships </h3>
      </div>
      <div className="inner-edu-about">
        <ol
          className="row"
          style={{
            listStyleType: "disc",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "evenly",

            lineHeight: "50px",
            marginLeft: "20px",
            marginTop: "60px",
            marginBottom: "50px",
            fontSize: "18px",
            fontWeight: "550",
            letterSpacing: ".225px",
            fontFamily: "Open Sans sans-serif",
          }}
        >
          <li className="col-lg-6 col-md-6 col-sm-12">
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              British Association of Dermatologist (BAD)
            </h5>
          </li>
          <li className="col-lg-6 col-md-6 col-sm-12">
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              British Medical Association (BMA)
            </h5>
          </li>
          <li className="col-lg-6 col-md-6 col-sm-12">
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              British Society of Dermatological Surgeons (BSDS)
            </h5>
          </li>
          <li className="col-lg-6 col-md-6 col-sm-12">
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              Midlands Dermatological Society (MDS)
            </h5>
          </li>
          <li className="col-lg-6 col-md-6 col-sm-12">
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              General Medical Council (GMC)
            </h5>
          </li>
          <li className="col-lg-6 col-md-6 col-sm-12">
            <h5
              style={{
                color: "#282828",
                fontFamily: "'Open Sans', sans-serif",
              }}
            >
              Medical Defence Union (MDU)
            </h5>
          </li>
        </ol>
      </div>
      <div className="footer-import footer-import-contact">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default AboutUsDetail;
